export const normalizeNumber = (val: string): number => {
  if (!val) return 0;
  // Convert full-width numbers to half-width
  const normalized = val.replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));
  // Remove any non-numeric characters except minus sign (though usually balance is positive, but adjustment might be negative? No, balance is absolute)
  // But let's just parse int.
  const parsed = parseInt(normalized, 10);
  return isNaN(parsed) ? 0 : parsed;
};
